
import { Component, Prop, Vue } from "vue-property-decorator";
import KeyManagersTable from "@/components/keys/managers/KeyManagersTable.vue";
import { Getter } from "vuex-class";

@Component({
  components: { KeyManagersTable },
})
export default class KeyGroupManagers extends Vue {

  @Prop({default: null})
  public keyGroup: any;

  @Prop({default: false})
  public isManager: boolean;

  @Getter private envCompany: any;

  get isCompanyBlocked(): boolean {
    return !!this.envCompany?.blockedAt;
  }
}
